import { Component } from 'react';
import { Media } from 'react-bootstrap';
import classNames from 'classnames';

import { Spinner } from '../../components/Spinner';
import { Text } from '../../components/Typography';

import { api } from '../../utils/api';

import classes from './add-warranty.module.scss';

interface Product {
  nome: string;
  immagine: string;
  codice_ean: string;
}

interface Props {
  code: string;
  onSelect: (code: string) => void;
}

interface State {
  fetching: boolean;
  error: boolean;
  data: Product[];
  selectedProduct: string | null;
}

export class ProductsList extends Component<Props, State> {
  state = {
    fetching: false,
    error: false,
    data: [],
    selectedProduct: null,
  };

  timeout?: NodeJS.Timeout;

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    snapshot?: any
  ): void {
    const { code } = this.props;

    if (prevProps.code !== code && code !== this.state.selectedProduct) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.getProductsByCode(code);
      }, 500);
    }
  }

  getProductsByCode = async (code?: string) => {
    if (code && code.length > 0) {
      this.setState({ fetching: true, error: false });

      try {
        const { data } = await api.get(`/product/${code}`);

        this.setState({ data });
      } catch {
        this.setState({ error: true, data: [] });
      } finally {
        this.setState({ fetching: false });
      }
    }
  };

  selectProduct = (productCode: string) => {
    this.props.onSelect(productCode);
    this.setState((prevState) => ({
      selectedProduct: productCode,
      data: [...prevState.data].filter(
        (product: Product) => product.codice_ean === productCode
      ),
    }));
  };

  render() {
    const { fetching, error, data } = this.state;
    const { code } = this.props;

    return (
      <div>
        <Spinner className={classes.spinner} show={fetching} />

        {error && <Text>Non esistono prodotti per il codice cercato</Text>}

        <ul className={'list-unstyled'}>
          {data.slice(0, 5).map((product: Product) => (
            <Media
              as={'li'}
              className={classNames(
                classes.listItem,
                code === product.codice_ean && classes.selected
              )}
              onClick={() => this.selectProduct(product.codice_ean)}
              key={product.codice_ean}
            >
              <img
                width={64}
                height={64}
                className={'mr-3'}
                src={product.immagine}
                alt={product.nome}
              />

              <Media.Body>
                <h5>{product.nome}</h5>

                <p>Codice prodotto: {product.codice_ean}</p>
              </Media.Body>
            </Media>
          ))}
        </ul>
      </div>
    );
  }
}
